import { useEffect } from 'react';

import { useMap } from 'react-map-gl';

import { LatLong } from 'src/common/external/aws/suggestPois';

import { fitBoundsToPoints } from './fitBoundsToPoints';
import { plotOrderedLocationsAsRouteLines } from './plotOrderedLocationsAsRouteLines';
import { removeAllLayersAndSources } from './removeAllLayersAndSources';

export function plotOrderedLocationsAsRoute(
  map: any,
  uiRouteLayerId: string,
  orderLocations: LatLong[]
) {
  try {
    // TODO: fitBoundsToPoints doesn't necessarily fit as a responsibility of plotting a route
    // For example, we have a popover for the live map that we may want to include the fitting calculation
    // but in the trip summary it's really just the route itself
    fitBoundsToPoints(map, orderLocations);
    removeAllLayersAndSources(map);
    plotOrderedLocationsAsRouteLines(map, uiRouteLayerId, orderLocations);
  } catch (error) {
    // TODO: failing silently -- styles load after our data
    // map.loaded() didn't really work in ensuring the styles loaded first
    // This is a temp workaround
    // This at least degrades gracefully instead of bringing the whole page
  }
}

export function useMapRoute(
  uiRouteLayerId: string,
  orderLocations: LatLong[],
  shouldPlotRoute: boolean
) {
  const { current: map } = useMap();
  useEffect(() => {
    // I'm sure Uncle Bob is going to find me for using a boolean function argument but this fixes a couple issues with the
    // live map without screwing up the trip summary and needing a larger refactor
    // which, as he'd recommend would need to use the lower level calls in plotOrderedLocationsAsRoute
    // closer to the use case
    if (shouldPlotRoute) {
      plotOrderedLocationsAsRoute(map, uiRouteLayerId, orderLocations);
    } else {
      if (map?.loaded()) {
        removeAllLayersAndSources(map);
      }
    }
  }, [
    map,
    uiRouteLayerId,
    orderLocations,
    orderLocations.length,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    map?.isStyleLoaded(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    map?.loaded(),
    shouldPlotRoute,
  ]);
}
